<template>
  <div class="upper-user x-dark-content x-flex-align">
    <!-- <span>欢迎您&nbsp;</span> -->
    <router-link
      class="user-name x-overflow-hidden"
      to="/personal"
      :title="data.username"
      :target="isUserCenterModule ? '_self' : '_blank'"
    >
      <span @click="onClickUserCenter">{{ data.username }}</span>
    </router-link>
    <i class="close ux_icon_shutdown" @click="showLoginOut"></i>
  </div>
</template>
<script>
export default {
  name: 'UpperUser',
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  computed: {
    // 是否用户中心模块
    isUserCenterModule() {
      return this.$route?.meta?.isUserCenterModule;
    }
  },

  methods: {
    /**
     * 弹出退出提示框
     */
    showLoginOut() {
      const confirmText = this.$t('HT.upperUser.exit');
      const title = this.$t('HT.upperUser.exit.title');
      const content = this.$t('HT.upperUser.exit.content');

      this.$uxModal.show({
        confirmText,
        title,
        content,
        confirm: () => {
          this.$emit('close');
        }
      });
    },
    onClickUserCenter() {
      if (this.isUserCenterModule) {
        window.location.reload();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.upper-user {
  height: 100%;
  font-size: 14px;

  .user-name {
    max-width: 100px;
    margin: 0 15px 0 10px;
    cursor: pointer;
  }

  .close {
    color: #777f8f;
    cursor: pointer;
    font-size: 16px;
  }

  .close:hover {
    color: #f56c6c;
  }
}
</style>
